export const IDLE_MS = 10 * 60 * 1000;
export const activityExpired = record => !record || !Number.isFinite(record.at) || Date.now() - record.at >= IDLE_MS || record.at > Date.now() + 30000;

export function activityChannel(handler) {
  if (typeof BroadcastChannel === 'undefined') return { publish: () => {}, close: () => {} };
  const channel = new BroadcastChannel('maldhowr-activity');
  channel.onmessage = event => handler(event.data);
  return { publish: record => channel.postMessage(record), close: () => channel.close() };
}